import { EMOJI_STUFEN, type EmojiStufe } from '../lib/mailBuilder/vorlagen';

const KURZ: Record<EmojiStufe, string> = { ohne: 'Ohne', normal: 'Normal', viele: 'Viele' };

/** Umschalter für die Emoji-Stufe einer Vorlage: ohne · normal · viele. */
export function EmojiStufenWahl({ id, wert, onChange }: { id: string; wert: EmojiStufe; onChange: (s: EmojiStufe) => void }) {
  return (
    <div className="emoji-stufen">
      <span className="emoji-stufen-label" id={id}>Emojis</span>
      <div className="seg-control seg-control--sm" role="group" aria-labelledby={id}>
        {EMOJI_STUFEN.map((s) => (
          <button
            key={s.wert}
            type="button"
            className={`seg-btn${wert === s.wert ? ' active' : ''}`}
            aria-pressed={wert === s.wert}
            title={`${s.label}: ${s.text}`}
            onClick={() => onChange(s.wert)}
          >
            {KURZ[s.wert]}
          </button>
        ))}
      </div>
    </div>
  );
}
